//import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'

const ProgrammableLink = ({
    href, onBeforeRedirect, target,
    children, className, id, style, title
}) => {
    //const parameters = useSelector(_ => _.search.parameters)
    const navigate = useNavigate()

    const generateUrl = () => {
        // Break for external urls
        if (href.startsWith('http'))
            return href
        
        return `${href}${window.location.search}`
    }

    return (
        <div
            id={id || ''}
            className={`programmable-link ${className}`}
            title={title || ''}
            style={style || {}}
            onClick={() => {
                onBeforeRedirect()
                    .then(() => {
                        typeof target === 'undefined' ?
                            navigate(generateUrl()) :
                            window.open(generateUrl(), target)
                    })
            }}>
            {children}
        </div>
    )
}

export default ProgrammableLink